import { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import {
    XMarkIcon,
    UsersIcon,
    UserIcon,
    EnvelopeIcon,
    PhoneIcon,
    BuildingOfficeIcon,
    CalendarIcon,
    LockClosedIcon,
    LockOpenIcon,
} from '@heroicons/react/24/outline'
import { formatDateAnTime, formatPhone } from '../../../../Common'

const DataField = ({ icon: Icon, label, value }) => (
    <div>
        <label className="flex items-center gap-1.5 text-xs font-semibold text-gray-500 uppercase tracking-wide mb-0.5">
            <Icon className="w-3.5 h-3.5" />{label}
        </label>
        <p className="mt-1 px-4 py-3 rounded-xl border border-gray-200 bg-gray-50 text-sm text-gray-800">{value || '—'}</p>
    </div>
)

const VisualizacaoInvestidorVinculado = ({ states, setters }) => {
    const item = states.InvestidoresInvestimentos || {}

    return (
        <Transition.Root show={states.modalViewInvestidoresInvestimentos} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={() => setters.setModalViewInvestidoresInvestimentos(false)}>
                <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
                    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4">
                        <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="ease-in duration-200" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95">
                            <Dialog.Panel className="w-full max-w-lg transform overflow-hidden rounded-2xl bg-white text-left shadow-2xl transition-all">

                                <div className="relative bg-gray-900 px-6 pt-6 pb-14 overflow-hidden">
                                    <div className="absolute -top-8 -right-8 w-40 h-40 rounded-full bg-brand-yellow/10" />
                                    <div className="absolute -bottom-12 -left-6 w-32 h-32 rounded-full bg-brand-yellow/5" />
                                    <div className="relative flex items-start justify-between">
                                        <div className="flex items-center gap-4">
                                            <div className="w-14 h-14 rounded-2xl bg-brand-yellow flex items-center justify-center flex-shrink-0 shadow-lg">
                                                <UsersIcon className="w-7 h-7 text-gray-900" />
                                            </div>
                                            <div>
                                                <span className="inline-block mb-1 px-2 py-0.5 rounded-md text-[10px] font-bold uppercase tracking-widest bg-blue-400/20 text-blue-300">Detalhes do Vínculo</span>
                                                <Dialog.Title as="h3" className="text-xl font-bold text-white truncate max-w-[16rem]">{item.nome_investidor || 'Investidor'}</Dialog.Title>
                                                <p className="text-sm text-gray-400 mt-0.5">{item.nome_empreendimento || 'Empreendimento'}</p>
                                            </div>
                                        </div>
                                        <button onClick={() => setters.setModalViewInvestidoresInvestimentos(false)} className="p-1.5 rounded-lg text-gray-500 hover:text-white hover:bg-white/10 transition-colors">
                                            <XMarkIcon className="w-5 h-5" />
                                        </button>
                                    </div>
                                </div>

                                <div className="relative -mt-6 mx-6 z-10">
                                    <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-5 space-y-4">
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                            <DataField icon={UserIcon} label="Investidor" value={item.nome_investidor} />
                                            <DataField icon={BuildingOfficeIcon} label="Empreendimento" value={item.nome_empreendimento} />
                                        </div>
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                            <DataField icon={EnvelopeIcon} label="E-mail" value={item.email_investidor} />
                                            <DataField icon={PhoneIcon} label="Telefone" value={formatPhone(item.telefone_investidor)} />
                                        </div>
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                            <DataField
                                                icon={item.ativo ? LockOpenIcon : LockClosedIcon}
                                                label="Status"
                                                value={item.ativo ? 'Ativo' : 'Inativo'}
                                            />
                                            <DataField icon={CalendarIcon} label="Criado em" value={formatDateAnTime(item.data_criacao)} />
                                        </div>
                                    </div>
                                </div>

                                <div className="flex justify-end px-6 pt-4 pb-6">
                                    <button type="button" onClick={() => setters.setModalViewInvestidoresInvestimentos(false)} className="px-5 py-2.5 rounded-xl text-sm font-semibold text-gray-600 bg-gray-100 hover:bg-gray-200 transition-all">Fechar</button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}

export default VisualizacaoInvestidorVinculado
